import Patients from "../views/Patients.vue";
import PatientCard from "../views/PatientCard.vue";
import Representatives from "../views/Representatives";
import RepresentativeCard from "../views/RepresentativeCard";
import patientWrapper from "@/modules/ras/views/patientWrapper";

export const routes = [
  {
    path: "/ras",
    name: "patientWrapper",
    component: patientWrapper,
    children: [
      { path: "", name: "Patients", component: Patients },
      {
        path: ":action/:id/:statusOfChangeId?",
        name: "patientCard",
        component: PatientCard
      }
    ]
  },

  {
    path: "/representatives",
    name: "Representatives",
    component: Representatives
  },
  {
    path: "/representatives/:action/:id",
    name: "representativeCard",
    component: RepresentativeCard
  }
];
